import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import PopupForm from "../components/PopupForm";
import FloatingBar from "../components/FloatingBar";
import AreaCarousel from "../components/AreaCarousel";
import ContactCards from "../components/ContactCards";
import WhyChooseUs from "../components/WhyChooseUs";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Booking from "../components/Booking";
import Reviews from "../components/Reviews";

export default function Home() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const visited = localStorage.getItem("ro_first_visit");
    if (!visited) {
      setTimeout(() => setShowPopup(true), 3000);
      localStorage.setItem("ro_first_visit", "true");
    }
  }, []);

  return (
    <>
      <Helmet>
        <title> RO Service Hazaribagh, Koderma & Ramgarh @ 9031062015 | Water Purifier Repair & Services</title>
        <meta
          name="description"
          content="Same day RO water purifier repair, installation & AMC services in Hazaribagh. Call or WhatsApp now for fast service."
        />
        <meta name="keywords" content="ro service, water purifier service in Hazaribagh, ro repair, ro service near me, water purifier service near me, RO Service Hazaribagh, RO Service Hazaribagh near me, ro service centre, ro service centre in Bihar" />
        <meta name="keywords" content="ro service in Hazaribagh" />
        <meta name="keywords" content="Water purifier service in Hazaribagh" />
        <meta name="keywords" content="ro repair in Hazaribagh" />
        <meta name="author" content="Wappotix Pvt Ltd" />
        <meta name="description" content="RO Service Hazaribagh: We are India's leading RO water purifier repair and maintanance service provider of all brands like Kent, Pureit, Livpure, Aqua Guard, Aqua Fresh etc. RO repair service in Hazaribagh" ></meta>

      </Helmet>

      <Hero title=" " number="9031062015" />
      <Services />
      <Booking />
      <WhyChooseUs />
      <Reviews />
      <AreaCarousel />
      <ContactCards />
      <FloatingBar />
      <PopupForm show={showPopup} onClose={() => setShowPopup(false)} />
    </>
  );
}